<!--
 * @Author: gang.liu
 * @Date: 2021-06-28 09:21:03
 * @LastEditTime: 2021-06-29 16:00:09
 * @LastEditors: gang.liu
 * @Description:
 * @api-property:
 * @api-event:
 * @api-method:
-->
<template>
  <div class="gy-home">
    <gy-header>
      <template slot="info">
        <div class="gy-home-control">
          <gy-divider />
          <div class="gy-home-control-item" title="个人中心">
            <router-link to="/login"><gy-icon icon="user" /></router-link>
          </div>
        </div>
      </template>
    </gy-header>
    <div class="gy-home-body overflow-y-auto overflow-x-hidden" :class="{bodyHight:!showflag}">
      <router-view />
    </div>
    <gy-footer></gy-footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showflag: true,
    };
  },
  created() {
    if (this.$route.path == "/register"&&this.browserRedirect()=='phone') {
      this.showflag = false;
    }
  },
  watch: {
    $route(to, from) {
      console.log(to.path, from.path);
      if (to.path == "/register"&&this.browserRedirect()=='phone') {
        this.showflag = false;
      }
    },
  },
  methods:{
    browserRedirect() {
      let sUserAgent = navigator.userAgent.toLowerCase();
      let bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
      let bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
      let bIsMidp = sUserAgent.match(/midp/i) == "midp";
      let bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
      let bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
      let bIsAndroid = sUserAgent.match(/android/i) == "android";
      let bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
      let bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
      if (
        bIsIpad ||
        bIsIphoneOs ||
        bIsMidp ||
        bIsUc7 ||
        bIsUc ||
        bIsAndroid ||
        bIsCE ||
        bIsWM
      ) {
        return 'phone'
      } else {
        return 'pc'
      }
    },
  }
}
</script>

<style lang="less">
.gy-home {
  height: 100vh;
  &-control {
    font-size: 24px;
    color: #ffffff;
    &-item {
      display: inline-block;
      padding: 0 20px;
      cursor: pointer;
    }
  }
  &-body {
    height: calc(100vh - 160px);
  }
}
.bodyHight{
  height: 100% !important;
}
</style>
